import { BuildingType } from '../../../types';
import type { CityStats, ResearchState } from '../../../types';

/** Evaluate whether a scenario objective description is met */
export function checkScenarioObjective(
  desc: string,
  stats: CityStats,
  counts: Record<string, number>,
  research?: ResearchState,
  violationCount?: number
): boolean {
  const descLower = desc.toLowerCase();

  if (descLower.includes('build')) {
    let met = false;
    const target = parseInt(desc.match(/Build (\d+)/i)?.[1] || '1');

    if (descLower.includes('pipeline') && (counts[BuildingType.Pipeline] || 0) >= target) met = true;
    else if (descLower.includes('road') && (counts[BuildingType.Road] || 0) >= target) met = true;
    else if (descLower.includes('policy hq') && (counts[BuildingType.ComplianceMgmt] || 0) >= target)
      met = true;
    else if (descLower.includes('audit') && (counts[BuildingType.Monitoring] || 0) >= target) met = true;
    else if (descLower.includes('support') && (counts[BuildingType.OpsComplaints] || 0) >= target)
      met = true;
    else if (descLower.includes('treasury') && (counts[BuildingType.OpsFunding] || 0) >= target)
      met = true;
    else if (descLower.includes('aml') && (counts[BuildingType.SecurityAML] || 0) >= target) met = true;
    else if (descLower.includes('sanctions') && (counts[BuildingType.Sanctions] || 0) >= target)
      met = true;
    else if (descLower.includes('firewall') && (counts[BuildingType.Firewall] || 0) >= target)
      met = true;
    else if (descLower.includes('siem') && (counts[BuildingType.SIEM] || 0) >= target) met = true;
    else if (descLower.includes('zero trust facility') && (counts[BuildingType.ZeroTrust] || 0) >= target)
      met = true;

    return met;
  }

  if (descLower.includes('research')) {
    if (!research) return false;
    if (descLower.includes('zero trust')) {
      return research.completedTechs.includes('tech_zerotrust');
    }
    return false;
  }

  if (descLower.includes('launch') || descLower.includes('stabilize crypto')) {
    if (descLower.includes('checking') && !stats.activeProducts.includes('prod_checking')) return false;
    if (descLower.includes('savings') && !stats.activeProducts.includes('prod_savings')) return false;

    if (descLower.includes('crypto')) {
      if (!stats.activeProducts.includes('prod_crypto')) return false;
      if (descLower.includes('risk < 5%') && stats.threat >= 5) return false;
    }
    return true;
  }

  if (descLower.includes('fix zone violation')) {
    if (violationCount === undefined) return false;
    return violationCount === 0;
  }

  let statMet = true;

  if (descLower.includes('comp')) {
    const val = parseInt(desc.match(/(\d+)%/)?.[1] || '0');
    if (stats.compliance < val) statMet = false;
  }

  if (descLower.includes('budget') || descLower.includes('$')) {
    let val = 0;
    if (descLower.includes('2k')) val = 2000;
    else if (descLower.includes('10k')) val = 10000;
    else if (descLower.includes('50k')) val = 50000;
    else if (descLower.includes('$2500')) val = 2500;
    else val = parseInt(desc.match(/\$(\d+)/)?.[1] || '0');

    if (val > 0 && stats.budget < val) statMet = false;
  }

  if (descLower.includes('threat')) {
    const val = parseInt(desc.match(/< (\d+)/)?.[1] || '20');
    if (stats.threat >= val) statMet = false;
  }

  if (descLower.includes('repay')) {
    if (stats.loanCount > 1) statMet = false;
  }

  return statMet;
}